import React, {useState, useEffect, useSyncExternalStore} from 'react';
import ScreenShot from './Screenshot';
import Payroll from './payroll/Payroll';
import UserSheets from './usertimesheets/UserSheets';
import Notify from '../Notify';
import FinishShift from './FinishShift';
import Time from '../Time';
import RetrieveShift from './RetrieveShift';
import Permissions from '../Permissions';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class TimeSheetBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      permissions: this.props.permissions,
      timerStatus:"Idle",
      startDateTime:"",
      finishDateTime:"",
      workingTime:0,
      breakTime:0,
      timerMessage: "Please start your shift",
      btnTextTimer : "Start shift",
      retrieveShift: false,
      payroll: false,
      finishShift: false,
      timeSheet:false,
      payrollPermission: false
    };

    this.countSeconds = this.countSeconds.bind(this);
    this.switchTimer = this.switchTimer.bind(this);
    this.endShift = this.endShift.bind(this);
    this.finishOldShift = this.finishOldShift.bind(this);
    this.resumeOldShift = this.resumeOldShift.bind(this);
    this.startShift = this.startShift.bind(this);
    this.checkStreamStatus = this.checkStreamStatus.bind(this);
    this.setOnlineStatus = this.setOnlineStatus.bind(this);
    this.closeRetrieveWindow = this.closeRetrieveWindow.bind(this);
    this.openPayroll = this.openPayroll.bind(this);
    this.openFinishShiftWindow = this.openFinishShiftWindow.bind(this);
    this.checkPermissions = this.checkPermissions.bind(this);
    this.openTimeSheets = this.openTimeSheets.bind(this);
    this.checkNotFinishedShift = this.checkNotFinishedShift.bind(this);
    this.screenshot = React.createRef();
  }

  //These actions happen every second the clock is On
  //Depending on the situation a different action is triggered
  countSeconds = () => {
    const timerState = this.state.timerStatus;
    let timeWorking = this.state.workingTime;
    let timeResting = this.state.breakTime;

    switch (timerState) {
      case "Idle":
        break;
      case "Interrupted":
        timeWorking++;
        this.setState({workingTime: timeWorking});
        this.setOnlineStatus("Interrupted");
        if( Math.floor(timeWorking)%15 == 0){
          //Every 15 seconds it warns the user to share the screen
          Notify.alertText("Please share your screen!")
        }
        break;
      case "Working":
        this.checkStreamStatus();
        timeWorking++ 
        this.setState({workingTime: timeWorking});
        if( Math.floor(timeWorking)%60 == 0){
          //Every 30 seconds it keeps the user online in the database
          this.setOnlineStatus("Online");
        }
        break;
      case "Break":
        timeResting++;
        this.setState({breakTime:timeResting})
        localStorage.setItem("timeResting", Math.floor(timeResting/60));
        break;
      case "End":
        clearInterval(this.state.interval);
        break;
      default:
        break;
    }
  }
  /**
   * Changes the status of the user depending on what status the user is right now
   */
  switchTimer = async () => {
    const timerState = this.state.timerStatus;

    switch (timerState) {
      case "Idle":
        await this.startShift()
        await this.registerShift(this.props.user, Time.getComputerTimeDate(), "Office");
        break;
      case "Interrupted":
        let shiftInterval = this.state.interval;
        clearInterval(shiftInterval);
        await this.startShift()
        break;
      case "Working":
        this.setState({timerStatus:"Break"});
        this.setState({timerMessage:"On Break"});
        this.setOnlineStatus("On Break");
        this.setState({btnTextTimer:"Resume work"});
        this.screenshot.current.stopCapture();
        break;
      case "Break":
        await this.screenshot.current.startCapture();
        this.setState({timerStatus:"Working"});
        this.setState({timerMessage:"Work in progress"});
        this.setState({btnTextTimer:"Start break"});
        this.setOnlineStatus("Online");
        break;
      case "End":
        this.setState({workingTime: 0});
        this.setState({breakTime:0});
        await this.startShift();
        await this.registerShift(this.props.user, Time.getComputerTimeDate(), localStorage.getItem('location'));
        break;
      default:
        break;
    }

  }

  endShift =  async() =>{

    //Update the user status to the system
    this.setOnlineStatus("Offline")
    this.setState({timerStatus:"End"});
    this.setState({btnTextTimer:"Restart shift"});
    this.setState({timerMessage:"Shift finished have a great day"});
   
    //Stop the clock and the Screen Capture
    let shiftInterval = this.state.interval;
    clearInterval(shiftInterval);
    this.screenshot.current.stopCapture();
    
  }

  startShift = async() =>{
    await this.screenshot.current.startCapture();
    this.countSeconds();
    this.setState({timerStatus:"Working"});
    this.setState({btnTextTimer:"Start break"});
    this.setState({interval:setInterval(this.countSeconds, 1000)});
    this.setState({timerMessage:"Work in progress"});
    this.setOnlineStatus("Online")

    //Saves some information on localstorage of your computer
    localStorage.setItem("user", this.props.user);
    let startingTime = Time.getComputerTimeDate();
    localStorage.setItem("startingTime",startingTime)
  }
  
  //Check if the user is really sharing the screen
  checkStreamStatus = () =>{
    //this variable returns the stream status
    const streamResult = this.screenshot.current.checkStreamInfo();
    
    switch(streamResult){
      //If user is sharing nothing happens
      case "Stream Active and normal":
        break;
      //If user not sharing, it stops the work timer and ask for the user to restart it
      case "Stream not Active":
        this.setState({timerStatus:"Interrupted"});
        this.setState({btnTextTimer:"Retry"});
        this.setState({timerMessage:"Please share your screen"});
        Notify.alertText("Please share your screen");
        break;
      //If user is sharing anything but its monitor, it also stops the timer and request it to restart
      case "Stream Active but not monitor":
        this.setState({timerStatus:"Interrupted"});
        this.setState({btnTextTimer:"Retry"});
        this.setState({timerMessage:"Please share your monitor"});
        Notify.alertText("Please share your monitor");
        this.screenshot.current.stopCapture();
        break;
      default:
          break;  
    }

  }

  //Updates the user status in the database
  setOnlineStatus = (status) =>{
    var formdata = new FormData();
    formdata.append("name", this.props.user);
    formdata.append("status", status);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/users/usersetstatus.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  }

  //Create a shift on the database
  //It also retrieve the shiftId of this shift and saves on the user's localStorage 
  registerShift =  async(user, startTime, location) =>{

    var formdata = new FormData();
    formdata.append("username", user);
    formdata.append("startTimeDate", startTime);
    formdata.append("location", location);


    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/timesheet/startshift.php", requestOptions)
      .then(response => response.text())
      .then(result => localStorage.setItem("shiftId", result))
      .catch(error => console.log('error', error));
  }

  finishShiftOnline = async(shiftId,startTime,finishTime,breakTime) =>{

    
    var formdata = new FormData();
    formdata.append("shiftid", shiftId);
    formdata.append("startTimeDate", startTime);
    formdata.append("endTimeDate", finishTime);
    formdata.append("originalEndTimeDate", finishTime);
    formdata.append("breakMinutes", breakTime);


    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    await fetch("https://dashboard.realsexdoll.info/php/timesheet/endshift.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

      //Cleans Local Storage
        localStorage.removeItem("user");
        localStorage.removeItem("startingTime");
        localStorage.removeItem("timeResting");
        localStorage.removeItem("shiftId");

  }

  resumeOldShift = async(oldDateTime, breakSeconds, workSeconds) => {
    //Sets your starting Time
    console.log("oldDateTime:")
    console.log(oldDateTime)
    this.setState({startDateTime:oldDateTime})

    //Sets your break Time
    console.log("breakSeconds:")
    console.log(breakSeconds)
    this.setState({breakTime:breakSeconds*60})

    //Sets your work Time
    console.log("workSeconds:")
    console.log(workSeconds)
    this.setState({workingTime:workSeconds})

    
    await this.screenshot.current.startCapture();
    localStorage.setItem("startingTime",oldDateTime)
    this.countSeconds();
    this.setState({timerStatus:"Working"});
    this.setState({btnTextTimer:"Start break"});
    this.setState({interval:setInterval(this.countSeconds, 1000)});
    this.setState({timerMessage:"Work in progress"});
    this.setOnlineStatus("Online");
    
  }

  finishOldShift = async(shiftID,startTime,finishTime,breakTime)=>{
    await this.finishShiftOnline(shiftID,startTime,finishTime, breakTime/60);
  }

  openPayroll = () =>{
    let payrollOpen = this.state.payroll;
      this.setState({payroll:!payrollOpen})
  }

  openTimeSheets = () =>{
    let TimeSheetOpen = this.state.timeSheet;
      this.setState({timeSheet:!TimeSheetOpen})
  }

  openFinishShiftWindow = () =>{
    let finishWindow = this.state.finishShift;
      this.setState({finishShift:!finishWindow});
  }

  closeRetrieveWindow = () =>{
    this.setState({retrieveShift:false});
  }

  componentDidMount(){
    
    this.checkNotFinishedShift(this.props.user);

    /*
    //This code was not working very well so now we are only checking online
    //check if there is a shift in progress locally
    if (localStorage.getItem("user") === this.props.user) {
        this.setState({startDateTime:localStorage.getItem("startingTime")})
        this.setState({retrieveShift:true})
    }else{
    //check online if there is a non finished shift
      
    }

    */


    this.checkPermissions();

  }

  checkNotFinishedShift = async(user) =>{

    let lastShift;

    var formdata = new FormData();
    formdata.append("user", user);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    console.log('Checking past shifts...')

    await fetch("https://dashboard.realsexdoll.info/php/timesheet/getlastshift.php", requestOptions)
      .then(response => response.json())
      .then(result => lastShift = result)
      .catch(error => console.log('error', error));


    if(lastShift.EndTime == '0000-00-00 00:00:00'){
      localStorage.setItem("startingTime",lastShift.StartTime);
      localStorage.setItem("shiftId",lastShift.Id)
      this.setState({startDateTime:lastShift.StartTime});
      this.setState({retrieveShift:true});

    }

  }

  checkPermissions = async() =>{

    let permissionResult = await Permissions.checkPermission(this.props.user,"payroll")
    this.setState({payrollPermission:permissionResult})

    console.log(permissionResult);

  }


  render() {

    //Converts seconds to HH:MM:SS
    //Work time
    const workingSeconds = this.state.workingTime;
    let workingTimer = new Date(workingSeconds * 1000).toISOString().substr(11, 8);
    
    //Break time
    const breakSeconds = this.state.breakTime;
    let breakTimer = new Date(breakSeconds * 1000).toISOString().substr(11, 8);

    const timerState = this.state.timerStatus;
    let finishShiftButton;

    let finishShiftHTML;
    if(this.state.finishShift){
      finishShiftHTML = 
        <FinishShift 
          close={this.openFinishShiftWindow}
          startTime={localStorage.getItem("startingTime")}
          user={this.props.user}
          breakTime={localStorage.getItem("timeResting")}
          shiftId = {localStorage.getItem("shiftId")}
          end = {this.endShift}
        />
    }

    //Give some conditions for the Finish button appears
    if(timerState !== "Idle" && timerState !== "Interrupted" && timerState !== "End"){
      finishShiftButton = <button className='' onClick={this.openFinishShiftWindow}>Finish shift</button>
    }

    //Payroll Window
    let payrollHtml;
    if(this.state.payroll){
      payrollHtml = <Payroll 
      close={this.openPayroll}
      user={this.props.user}
      />
    }

    //User Time Sheet Window
    let userSheetsHtml;
    if(this.state.timeSheet){
      userSheetsHtml = <UserSheets 
      close={this.openTimeSheets}
      user={this.props.user}
      />
    }

    //Payroll Button
    let payrollBtn;
    let userSheetsBtn; 
    //Checks if you have permission to see this button
    if(this.state.payrollPermission){
      payrollBtn = <button onClick={this.openPayroll}>Payroll</button>
    }else{
      userSheetsBtn = <button onClick={this.openTimeSheets}>Sheets</button>
    }

    //If user forgets to finish a shift this will appear
    let retrieveShift;
    if(this.state.retrieveShift){
        retrieveShift = 
        <RetrieveShift
          user = {this.props.user}
          close = {this.closeRetrieveWindow} 
          finishOldShift = {this.finishOldShift}
          resumeOldShift = {this.resumeOldShift}
        />
    }
    
    return(
      <div className='board'>
        {retrieveShift}
         <header>
              <div className="row">
                <div className='col-12'>
                  <h2>Time Sheet</h2>
                </div>
              </div>
          </header>
        <div className='wrapper-white'>
          <div className='container-fluid'>
            <h5>Time Working: {workingTimer}</h5>
            <h5>Time On Break: {breakTimer}</h5>
            <p className='text-center'>{this.state.timerMessage}</p>
          </div>
        </div>
        <footer>
          <div className="row">
            <div className='col-12'>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button onClick={this.switchTimer}> {this.state.btnTextTimer}</button>
                {finishShiftButton}
                {payrollBtn}
                {userSheetsBtn}
              </div>
            </div>
          </div>
        </footer>
          <ScreenShot ref={this.screenshot} title="ScreenShot" user={this.props.user}/>
          {finishShiftHTML}
          {payrollHtml}
          {userSheetsHtml}
      </div>
    );
  }
}

export default TimeSheetBoard;